import { Link } from "react-router-dom";
import { Ticket, EnvelopeSimple, Phone, MapPin, Clock, WhatsappLogo } from "@phosphor-icons/react";
import { BUSINESS } from "@/lib/site";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 mt-16 bg-black/40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 bg-primary flex items-center justify-center neon-glow">
              <Ticket weight="fill" size={20} className="text-black" />
            </div>
            <span className="font-heading font-black text-xl tracking-tighter text-white">
              EVENT<span className="text-primary">KU</span>
            </span>
          </div>
          <p className="text-sm text-zinc-500 leading-relaxed">Platform tiket acara end-to-end: beli tiket, terima E-Ticket ber-QR, dan masuk tanpa antre.</p>
          <p className="text-xs text-zinc-600 mt-4">Dikelola oleh<br /><span className="text-zinc-400 font-semibold">{BUSINESS.name}</span></p>
        </div>

        <div>
          <h4 className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary mb-4">Navigasi</h4>
          <ul className="space-y-2.5 text-sm text-zinc-400">
            <li><Link to="/" data-testid="footer-link-home" className="hover:text-primary transition-colors">Acara</Link></li>
            <li><Link to="/tickets" className="hover:text-primary transition-colors">Tiket Saya</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-primary transition-colors">Kontak</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary mb-4">Bantuan & Legal</h4>
          <ul className="space-y-2.5 text-sm text-zinc-400">
            <li><Link to="/faq" data-testid="footer-link-faq" className="hover:text-primary transition-colors">FAQ</Link></li>
            <li><Link to="/terms" data-testid="footer-link-terms" className="hover:text-primary transition-colors">Syarat & Ketentuan</Link></li>
            <li><Link to="/refund" data-testid="footer-link-refund" className="hover:text-primary transition-colors">Kebijakan Refund</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary mb-4">Kontak Usaha</h4>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li className="flex gap-2"><MapPin size={16} className="text-primary shrink-0 mt-0.5" /> <span>{BUSINESS.address}</span></li>
            <li className="flex gap-2 items-center"><EnvelopeSimple size={16} className="text-primary shrink-0" /> <a href={`mailto:${BUSINESS.email}`} className="hover:text-primary transition-colors break-all">{BUSINESS.email}</a></li>
            <li className="flex gap-2 items-center"><Phone size={16} className="text-primary shrink-0" /> <a href={`tel:${BUSINESS.phone}`} className="hover:text-primary transition-colors">{BUSINESS.phone}</a></li>
            <li className="flex gap-2 items-center"><Clock size={16} className="text-primary shrink-0" /> {BUSINESS.hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-zinc-600 flex flex-col sm:flex-row gap-2 sm:justify-between">
          <span>© 2026 {BUSINESS.name}. Seluruh hak cipta dilindungi.</span>
          <span>EventKu — Sistem Ticketing Acara</span>
        </div>
      </div>
    </footer>
  );
}
